export const verifiedDirectorOwnerRequiredError = 'verified-director-owner-required';
